import { DESKTOP_MIN_WIDTH } from 'Component/CategorySort/CategorySort.config';

// eslint-disable-next-line no-magic-numbers,import/prefer-default-export
export const PAGE_SIZE = (window.innerWidth >= DESKTOP_MIN_WIDTH) ? 36 : 10;
export const observerThreshold = 10;
export const INTERSECTION_RATIO = 0.5;
